import { render } from "./ReturnLetter.vue?vue&type=template&id=f0ca90f2&ts=true"
import script from "./ReturnLetter.vue?vue&type=script&lang=ts"
export * from "./ReturnLetter.vue?vue&type=script&lang=ts"

import "./ReturnLetter.vue?vue&type=style&index=0&id=f0ca90f2&lang=scss"

import exportComponent from "/builds/rma/ufg-rma/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__